import { FC } from 'react';

interface YQIconPropsType {
  src: string;
  width: number | string;
  height: number | string;
  className?: string;
}

const YQIcon: FC<YQIconPropsType> = function YQIcon({
  src,
  width,
  height,
  className,
}) {
  return (
    <div
      className={className}
      style={{
        width: `${typeof width === 'number' ? `${width / 100}rem` : width}`,
        height: `${typeof height === 'number' ? `${height / 100}rem` : height}`,
        background: `url(${src}) no-repeat`,
        backgroundSize: '100% 100%',
      }}
    />
  );
};

export default YQIcon;

YQIcon.defaultProps = {
  className: '',
};
